import { useState } from "react";
import { useOperatorActions } from "../../../../utils/useOperatorActions";
import CyberBoxComponent from "../../../shared/ui/layout/CyberBoxComponent";
import WelcomeComponent from "../day-1/components/welcomeComponent";
import DuelComponent from "./components/DuelComponent";
import { DuelIntroComponent } from "./components/DuelIntroComponent";

export function Day4() {
  const [currentHtml, setCurrentHtml] = useState(null);
  useOperatorActions("SHOW_INTRO", () => {
    setCurrentHtml("SHOW_INTRO");
  });
  useOperatorActions("IRONBEARS_GOLDENEAGLES", () => {
    setCurrentHtml("IRONBEARS_GOLDENEAGLES");
  });
  useOperatorActions("IRONBEARS_BULLMASTERS", () => {
    setCurrentHtml("IRONBEARS_BULLMASTERS");
  });
  useOperatorActions("IRONBEARS_ALPHAWOLVES", () => {
    setCurrentHtml("IRONBEARS_ALPHAWOLVES");
  });
  useOperatorActions("GOLDEN_EAGLES_ALPHAWOLVES", () => {
    setCurrentHtml("GOLDEN_EAGLES_ALPHAWOLVES");
  });
  useOperatorActions("GOLDEN_EAGLES_BULLMASTERS", () => {
    setCurrentHtml("GOLDEN_EAGLES_BULLMASTERS");
  });
  useOperatorActions("BULLMASTERS_ALPHAWOLVES", () => {
    setCurrentHtml("BULLMASTERS_ALPHAWOLVES");
  });

  const renderHtml = (html) => {
    switch (html) {
      case "IRONBEARS_GOLDENEAGLES":
        return <DuelComponent identifier={"IRONBEARS_GOLDENEAGLES"} />;
      case "IRONBEARS_BULLMASTERS":
        return <DuelComponent identifier={"IRONBEARS_BULLMASTERS"} />;
      case "IRONBEARS_ALPHAWOLVES":
        return <DuelComponent identifier={"IRONBEARS_ALPHAWOLVES"} />;
      case "GOLDEN_EAGLES_ALPHAWOLVES":
        return <DuelComponent identifier={"GOLDEN_EAGLES_ALPHAWOLVES"} />;
      case "GOLDEN_EAGLES_BULLMASTERS":
        return <DuelComponent identifier={"GOLDEN_EAGLES_BULLMASTERS"} />;
      case "BULLMASTERS_ALPHAWOLVES":
        return <DuelComponent identifier={"BULLMASTERS_ALPHAWOLVES"} />;
      case "SHOW_INTRO":
        return (
          <CyberBoxComponent>
            <DuelIntroComponent />
          </CyberBoxComponent>
        );
      default:
        <WelcomeComponent />;
    }
  };
  return <>{renderHtml(currentHtml)}</>;
}

export default Day4;
